export default "__VITE_ASSET__BxlXwavL__"